import { render, staticRenderFns } from "./statistic_trans.vue?vue&type=template&id=ff1843ce&scoped=true"
import script from "./statistic_trans.vue?vue&type=script&lang=js"
export * from "./statistic_trans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1843ce",
  null
  
)

export default component.exports